<template>
  <div>
    <b-row class="mb-3">
      <b-col>
        <b-input v-model="keyword" :placeholder="t(['Search','ຊອກຫາ'])" />
      </b-col>
      <b-col class="text-right"></b-col>
    </b-row>

    <b-table
      caption-top
      :items="filteredItems"
      :fields="fields"
      :current-page="currentPage"
      :per-page="perPage"
      :filter="filter"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      head-variant="dark"
    >
      <template slot="index" slot-scope="data">{{ data.index + 1 }}</template>
      <template slot="totalAmount" slot-scope="data">{{data.item.totalAmount | numberformat}}</template>
      <template slot="createDate" slot-scope="data">{{ data.item.createDate.seconds | datetime }}</template>
      <template slot="orderStatus" slot-scope="data">
        <OrderStatus :orderStatus="data.item.orderStatus" />
      </template>
      <template slot="actions" slot-scope="data">
        <b-button-group>
          <b-button v-b-modal.modal @click="view(data.item)" variant="primary">
            <i class="fa fa-eye"></i>
          </b-button>
          <router-link
            class="btn btn-secondary"
            target="_blank"
            :to="'/printOrder/' + data.item.id"
          >
            <i class="fa fa-print"></i>
          </router-link>
        </b-button-group>
      </template>
    </b-table>

    <b-pagination
      v-if="filteredItems && filteredItems.length > 0"
      v-model="currentPage"
      :total-rows="filteredItems.length"
      :limit="10"
      align="center"
      size="sm"
      class="mt-3"
    />

    <b-modal
      header-bg-variant="dark"
      id="modal"
      :title="'Order - ' + model.orderNo"
      v-if="model"
      size="lg"
      :hide-footer="true"
    >
      <b-card>
        <b-row class="mb-3">
          <b-col class="text-center">
            {{t(['Customer',''])}}:
            <h4 class="text-center">{{model.customerName}}</h4>
          </b-col>
          <b-col class="text-center">
            {{t(['Tel',''])}}:
            <h4 class="text-center">{{model.customerContactNumber}}</h4>
          </b-col>
          <b-col class="text-center">
            {{t(['Status',''])}}:
            <OrderStatus :orderStatus="model.orderStatus" />
          </b-col>
        </b-row>
        <b-row>
          <b-col class="text-center">
            {{t(['Payment Type',''])}}:
            <h4 class="text-center">
              <b-badge variant="success" v-if="model.paymentType == 0">CASH</b-badge>
              <b-badge variant="danger" v-if="model.paymentType == 1">ONEPAY</b-badge>
            </h4>
          </b-col>
          <b-col class="text-center">
            {{t(['Payment Status',''])}}:
            <h4 class="text-center">
              <b-badge variant="danger" v-if="model.paymentStatus == 0">PENDING</b-badge>
              <b-badge variant="success" v-if="model.paymentStatus == 1">PAID</b-badge>
            </h4>
          </b-col>
          <b-col class="text-center">
            {{t(['Total',''])}}:
            <h4 class="text-center">{{model.totalAmount | numberformat}}</h4>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="text-center">
            {{t(['Comment',''])}}:
            <h4 class="text-center">{{model.orderComment}}</h4>
            </b-col>
        </b-row>
      </b-card>
      <b-tabs>
        <b-tab :title="'Menu'">
          <table class="table">
            <thead>
              <tr>
                <th>{{t(['No.',''])}}</th>
                <th>{{t(['Name',''])}}</th>
                <th class="text-right">{{t(['Qty',''])}}</th>
                <th class="text-right">{{t(['Total',''])}}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in model.cartItems" :key="index">
                <td>{{index + 1}}</td>
                <td>
                  <div>{{item.menu.code}} {{item.menu.name}}</div>
                  <div>{{item.comment}}</div>
                </td>
                <td class="text-right">{{item.quantity | numberformat}}</td>
                <td class="text-right">{{item.quantity * item.menu.price | numberformat}}</td>
              </tr>
            </tbody>
          </table>
        </b-tab>
        <b-tab :title="'Delivery'">
          <b-row>
            <b-col>
              <table class="table table-bordered">
                <tbody>
                  <tr>
                    <td>{{t(['Name',''])}}</td>
                    <th>{{model.deliveryName}}</th>
                  </tr>
                  <tr>
                    <td>{{t(['Tel',''])}}</td>
                    <th>{{model.deliveryContact}}</th>
                  </tr>
                  <tr>
                    <td>{{t(['Address',''])}}</td>
                    <th>{{model.deliverAddress}}</th>
                  </tr>
                  <tr>
                    <td>{{t(['Location',''])}}</td>
                    <th>{{model.deliverLocation}}</th>
                  </tr>
                  <tr>
                    <td>{{t(['Fee',''])}}</td>
                    <th>{{model.deliverFee | numberformat}}</th>
                  </tr>
                </tbody>
              </table>
            </b-col>
            <b-col cols="7" v-if="model.deliverLocation.indexOf('gps: ') >= 0">
              <GmapMap
                :center="getLatLng(model.deliverLocation)"
                :zoom="15"
                map-type-id="terrain"
                style="width: 100%; height: 300px"
              >
                <GmapMarker
                  :clickable="true"
                  :title="model.deliveryName"
                  :position="getLatLng(model.deliverLocation)"
                />

                <GmapInfoWindow :opened="true">
                  <div>{{model.deliveryName}}</div>
                  <div>{{model.deliveryContact}}</div>
                </GmapInfoWindow>
              </GmapMap>
            </b-col>
          </b-row>
        </b-tab>
        <b-tab :title="'Timeline'">
          <table class="table">
            <thead>
              <tr>
                <th>{{t(['Time</th>
                <th>{{t(['User</th>
                <th class="text-center">{{t(['Status</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in model.logs" :key="index">
                <td>{{item.time}}</td>
                <td>{{item.user}}</td>
                <td class="text-center">
                  <OrderStatus :orderStatus="item.status" />
                </td>
              </tr>
            </tbody>
          </table>
        </b-tab>
      </b-tabs>

      <b-row class="mt-3">
        <b-col cols="3">
          <b-button-group>
            <router-link class="btn btn-secondary" :to="'printOrder/' + model.id" target="_blank">
              <i class="fa fa-print"></i> Print
            </router-link>
          </b-button-group>
        </b-col>
        <b-col class="text-right">
          <b-button-group>
            <b-button variant="danger" @click="update(-1)">
              <i class="fa fa-trash"></i> Reject
            </b-button>
            <b-button variant="warning" @click="update(1)">
              <i class="fa fa-cog"></i> Processing
            </b-button>
            <b-button variant="info" @click="update(2)">
              <i class="fa fa-send"></i> Sending
            </b-button>
            <b-button variant="success" @click="update(3)">
              <i class="fa fa-check"></i> Complete
            </b-button>
          </b-button-group>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import firebase from "firebase/app";
import OrderStatus from "../components/OrderStatus";
export default {
  name: "OrderTable",
  components: { OrderStatus },
  props: {
    items: null,
    canAdd: false
  },
  computed: {
    filteredItems: function() {
      if (this.keyword && this.items)
        return this._.filter(this.items, i => {
          if (this.match(this.keyword, i.orderNo)) return true;
          if (this.match(this.keyword, i.customerName)) return true;
          if (this.match(this.keyword, i.customerContactNumber)) return true;
          return false;
        });
      else return this.items;
    },
    sortOptions() {
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    }
  },
  data() {
    return {
      model: null,
      keyword: null,
      fields: [
        { key: "index", label: "#" },
        { key: "orderNo", sortable: true, label: "No." },
        { key: "createDate", sortable: true, label: "Time" },
        { key: "customerName", sortable: true, label: "Customer" },
        { key: "customerContactNumber", sortable: true, label: "Tel" },
        {
          key: "totalAmount",
          sortable: true,
          class: "text-right",
          label: "Total"
        },
        {
          key: "orderStatus",
          sortable: true,
          label: "Status",
          class: "text-center"
        },
        { key: "actions", class: "text-right" }
      ],
      currentPage: 1,
      perPage: 20,
      sortDesc: false,
      sortDirection: "asc",
      sortBy: "",
      filter: null
    };
  },
  methods: {
    getLatLng(location) {
      if (location.indexOf("gps: ") < 0) return null;
      const rep = location.replace("gps: ", "");
      const reps = rep.split(",");
      return { lat: parseFloat(reps[0]), lng: parseFloat(reps[1]) };
    },
    view(item) {
      this.model = item;
    },
    update(s) {
      this.model.orderStatus = s;
      if (!this.model.logs || this.model.logs.length === 0)
        this.model.logs = [];
      const time = this.moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
      const user = firebase.auth().currentUser.email;
      this.model.logs.push({
        time: time,
        status: s,
        user: user
      });
      firebase
        .firestore()
        .collection("orders")
        .doc(this.model.id)
        .update(this.model)
        .then(() => {
          this.$bvModal.hide("modal");
          this.model = null;
        });
    }
  }
};
</script>